import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";

import { CallDetailsComponent } from "./call-details.component";
import { PipeModule } from "app/pipes/pipe.module";
import { AsyncClickModule } from 'app/directives/async-click/async-click.module';
import { SurveyModule } from "app/client/components/survey/survey.module";

@NgModule({
  declarations: [
    CallDetailsComponent
  ],
  imports: [
    SurveyModule,
    FormsModule,
    CommonModule,
    AsyncClickModule,
    PipeModule
  ]
})
export class CallDetailsModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/client/call/details/call-details.module.ts